export default "__VITE_PUBLIC_ASSET__68572bef__"